import { EasyField } from '../baseClasses/easyField';
import { FieldOptions } from '../index';

export class EasyTextAreaField extends EasyField {
  controlType = 'textArea';
  type: string;

  constructor(options: FieldOptions<string> = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}
